/**
 * See also: TimesheetManagementTypes in Constants.cs
 */
export const TimesheetTypes = [
    { label: 'Crew', value: 1 },
    { label: 'Lowboy', value: 2 },
    { label: 'Time Off Request', value: 3 },
    { label: 'Timesheet', value: 4 },
];
